import { Link } from "react-router-dom";
import CanvasParticles from "../components/CanvasParticles";

interface FAQArticleData {
  title: string;
  content: string;
  category: string;
}

interface FAQArticleProps {
  data: FAQArticleData;
}

export default function FAQArticlePage({ data }: FAQArticleProps) {
  return (
    <div className="min-h-screen font-sans relative overflow-x-hidden bg-[#0a0a0a]">
      {/* Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[#0a0a0a]" />
      </div>

      {/* Header */}
      <header className="bg-[#0a0a0a]/80 backdrop-blur-md border-b border-white/[0.08] relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="text-white/60 hover:text-white transition-colors">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-left-line text-xl" />
              </div>
            </Link>
            <h1 className="text-xl font-semibold text-white absolute left-1/2 transform -translate-x-1/2">
              Help Center
            </h1>
            <div className="w-8" />
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative min-h-[25vh] flex items-center overflow-hidden">
        <CanvasParticles />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-[#0a0a0a]" />
        <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 py-10 md:py-14">
          <div className="max-w-7xl mx-auto text-center">
            <p className="text-white/40 text-xs uppercase tracking-widest mb-3">{data.category}</p>
            <h2 className="text-white text-2xl md:text-4xl font-light tracking-tight">
              {data.title}
            </h2>
          </div>
        </div>
      </section>

      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 pb-10 relative z-10">
        <div className="bg-[#111111]/60 backdrop-blur-sm rounded-2xl border border-white/[0.08] p-8 md:p-10">
          <div className="text-white/70 text-sm md:text-base leading-relaxed whitespace-pre-line">
            {data.content}
          </div>
          <div className="mt-10 pt-8 border-t border-white/[0.06]">
            <p className="text-sm text-white/40 mb-4">
              Still need help? Contact our support team.
            </p>
            <Link
              to="/contact-support"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white text-[#0a0a0a] text-sm font-medium hover:bg-white/90 transition-colors whitespace-nowrap"
            >
              Contact Support
              <span className="w-8 h-8 rounded-full bg-[#0a0a0a] flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-sm" />
              </span>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}